import { useMutation } from '@tanstack/react-query';

import * as folderServices from 'services/folder';
import { dialogFunctionAsync, CustomNotification } from 'common/components';

import { getManageScheduleDownloadKey } from './queries';

export const useCancelScheduleDownload = ({ folderId }) => {
  const cancelScheduleDownload = useMutation({
    mutationKey: ['cancel-schedule-download-folder'],
    mutationFn: async (params) => {
      try {
        return folderServices.cancelFolderScheduleDownload(params);
      } catch (error) {
        console.error('error: ', error);
      }
    },
    meta: {
      invalidates: [getManageScheduleDownloadKey(folderId)],
    },
  });

  const showCancelConfirm = () => {
    return dialogFunctionAsync({
      type: 'warn',
      content: 'Are you sure you want to cancel download',
    });
  };

  const showCancelMessage = (status, message) => {
    if (status === 'success') {
      CustomNotification.success('Cancel Schedule successfully');
    } else {
      CustomNotification.error(message || 'Fail to cancel Schedule');
    }
  };

  return { cancelScheduleDownload, showCancelConfirm, showCancelMessage };
};
